module.exports = __webpack_public_path__ + "img/cover-2.496f41f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cover-2.jpg
// module id = t64f
// module chunks = 1